const CalendarAdd = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 5a2.5 2.5 0 0 0-2.5 2.5v10A2.5 2.5 0 0 0 7 20h5.5a.5.5 0 0 0 0-1H7a1.5 1.5 0 0 1-1.5-1.5v-8h13V13a.5.5 0 0 0 1 0V7.5A2.5 2.5 0 0 0 17 5h-1V3a.5.5 0 0 0-1 0v2H9V3a.5.5 0 0 0-1 0v2zm0 1a1.5 1.5 0 0 0-1.5 1.5v1h13v-1A1.5 1.5 0 0 0 17 6z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.5 20H16a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356A.48.48 0 0 1 16 19h2.5v-2.5q0-.212.144-.356a.49.49 0 0 1 .357-.144q.212 0 .356.144a.49.49 0 0 1 .143.356V19H22q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356A.49.49 0 0 1 22 20h-2.5v2.5q0 .212-.144.356a.49.49 0 0 1-.357.144.48.48 0 0 1-.356-.144.49.49 0 0 1-.143-.356z"
    />
  </>
)
export default CalendarAdd
